package com.flowyride.feature.navigation

import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.navigation.NavigationSnapshot
import org.jetbrains.compose.resources.StringResource

/** Shown once arrived. */
data class RideSummary(
    val distanceMeters: Double,
    val durationSeconds: Double,
) {
    val averageSpeedKmh: Double
        get() = if (durationSeconds > 0) distanceMeters / durationSeconds * 3.6 else 0.0
}

data class NavigationUiState(
    val name: String = "",
    /** The whole ride. */
    val track: List<GeoPoint> = emptyList(),
    val stops: List<GeoPoint> = emptyList(),
    /** Cameras on the ride, drawn only when alerts are on. */
    val speedCameras: List<GeoPoint> = emptyList(),
    val simulated: Boolean = false,
    /** Imported line: its turn-by-turn instructions are being fetched. */
    val preparing: Boolean = false,
    val snapshot: NavigationSnapshot? = null,
    /** Added to the automatic zoom by the +/− buttons. */
    val zoomOffset: Double = 0.0,
    /** The whole ride, north up, instead of following the rider. */
    val overview: Boolean = false,
    /** The rider moved the map by hand: the camera stops following until recentred (button or riding on). */
    val mapMovedByHand: Boolean = false,
    val speedCameraAlerts: Boolean = false,
    val summary: RideSummary? = null,
    /** The last way back could not be computed (network): the arrow points at the ride meanwhile. */
    val connectorFailed: Boolean = false,
    /** GPS permission refused. */
    val locationDenied: Boolean = false,
)

sealed interface NavigationAction {
    data object ZoomIn : NavigationAction
    data object ZoomOut : NavigationAction
    data object Stop : NavigationAction
    data object ToggleOverview : NavigationAction
    /** A gesture moved the map. */
    data object MapMoved : NavigationAction
    /** Back to following the rider. */
    data object Recenter : NavigationAction
    data object LocationDenied : NavigationAction
    /** Permission granted (or not needed): the navigation can use the GPS. */
    data object LocationGranted : NavigationAction
}

sealed interface NavigationUiEvent {
    data class ShowMessage(val message: StringResource, val argument: String? = null) : NavigationUiEvent
}
